import type { FilteredArea } from "./area-filtering";

/**
 * エリア・サイトのソートユーティリティ
 * Co-Owners / Owners 向けに自己所有物件を優先的に表示する
 */

function compareByOwned(a: FilteredArea, b: FilteredArea): number {
  const aHasOwned = a.sites.some((s) =>
    s.accommodations.some((acc) => acc.isOwned === true),
  );
  const bHasOwned = b.sites.some((s) =>
    s.accommodations.some((acc) => acc.isOwned === true),
  );
  if (aHasOwned === bHasOwned) return 0;
  return aHasOwned ? -1 : 1;
}

/**
 * 自己所有物件のあるエリアを先頭に並べる
 */
export function sortAreas(areas: FilteredArea[]): FilteredArea[] {
  return [...areas].sort(compareByOwned);
}

/**
 * エリアフィルタを考慮したソート
 * 選択エリアを上部に、未選択エリアを下部に配置。
 * 各グループ内では owned 優先ソートを適用。
 */
export function sortAreasWithAreaFilter(
  areas: FilteredArea[],
  selectedSlugs: ReadonlySet<string>,
): FilteredArea[] {
  if (selectedSlugs.size === 0) return sortAreas(areas);
  return [...areas].sort((a, b) => {
    const aSelected = selectedSlugs.has(a.slug);
    const bSelected = selectedSlugs.has(b.slug);
    if (aSelected !== bSelected) return aSelected ? -1 : 1;
    return compareByOwned(a, b);
  });
}

/**
 * 自己所有物件のあるサイトを先頭に並べる
 */
export function sortSites(sites: FilteredArea["sites"]): FilteredArea["sites"] {
  return [...sites].sort((a, b) => {
    const aHasOwned = a.accommodations.some((acc) => acc.isOwned === true);
    const bHasOwned = b.accommodations.some((acc) => acc.isOwned === true);
    if (aHasOwned === bHasOwned) return 0;
    return aHasOwned ? -1 : 1;
  });
}
